// Auto-extracted from Profile.jsx
import { useState, useEffect, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Btn } from "../../components/Btn";
import { Eyebrow } from "../../components/Eyebrow";
import { Icon } from "../../components/Icon";
import { Skeleton } from "../../components/Skeleton";
import { EmptyState } from "../../components/EmptyState";
import { ProductCard } from "../../components/ProductCard";
import { supabase } from "../../lib/supabase";
import { fmtK } from "../../lib/money";
import { useWishlist } from "../../store/wishlistStore";
import { getAllLocations } from "../../data/zambianLocations";
import { timeAgo } from "../../lib/dateUtils";
import { useCategories } from "../../hooks/useCategories";
import { BecomeSellerModal } from "../../components/BecomeSellerModal";
import { PhoneVerificationModal } from "../../components/PhoneVerificationModal";
import { DeleteAccountModal } from "../../components/DeleteAccountModal";
import { Field, SecurityRow, InfoRow, inputStyle } from "./shared";

export function SellerReviewsPanel({ seller }) {
  const { data: rows = [], isLoading: loading } = useQuery({
    queryKey: ["seller-reviews", seller?.id],
    enabled: !!seller?.id,
    staleTime: 60_000,
    queryFn: async () => {
      const { data } = await supabase
        .from("reviews")
        .select("id, rating, text, created_at, buyer:users!reviews_buyer_id_fkey(name, avatar_url)")
        .eq("seller_id", seller.id)
        .order("created_at", { ascending: false })
        .limit(30);
      return data || [];
    },
  });

  if (!seller) return <EmptyState icon="star" title="No store linked" body="Switch to a seller account." />;
  if (loading) return <Skeleton h={80} />;
  if (rows.length === 0) return <EmptyState icon="star" title="No reviews yet" body="Reviews from buyers will appear here." />;

  return (
    <div style={{ display: "grid", gap: 10 }}>
      {rows.map((r) => (
        <Card key={r.id}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <div style={{
              width: 36, height: 36, borderRadius: 10,
              background: r.buyer?.avatar_url ? `url(${r.buyer.avatar_url}) center/cover` : C.hunter,
              color: C.dust, display: "inline-flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 800,
            }}>
              {!r.buyer?.avatar_url && (r.buyer?.name?.[0] || "?").toUpperCase()}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 800 }}>{r.buyer?.name || "Buyer"}</div>
              <div style={{ fontSize: 11, color: C.muted }}>{"⭐".repeat(r.rating)} · {new Date(r.created_at).toLocaleDateString()}</div>
            </div>
          </div>
          {r.text && <p style={{ fontSize: 13, color: C.slate, margin: 0, lineHeight: 1.5 }}>{r.text}</p>}
        </Card>
      ))}
    </div>
  );
}
